import { FC, useEffect, useRef, useState } from 'react';
import './styles.css';

type Props = { text: string; compact?: boolean };

const MarqueeText: FC<Props> = ({ text, compact = false }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [duration, setDuration] = useState(10); // default

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current && textRef.current) {
        const containerWidth = containerRef.current.clientWidth;
        const textWidth = textRef.current.scrollWidth;
        const overflowing = textWidth > containerWidth;

        setIsOverflowing(overflowing);

        if (overflowing) {
          const speed = 75; // px/sec
          setDuration(textWidth / speed);
        }
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [text]);

  return (
    <div
      ref={containerRef}
      className={`font-bold overflow-hidden whitespace-nowrap ${compact ? 'py-1 text-2xl' : 'py-2 text-lg sm:text-5xl'}`}
    >
      {isOverflowing ? (
        <div
          className="marquee"
          style={{ animationDuration: `${duration}s` }}
        >
          <span ref={textRef} className="marquee-text">{text}</span>
          <span className="marquee-text">{text}</span>
        </div>
      ) : (
        <span ref={textRef} className="truncate block">{text}</span>
      )}
    </div>
  );
};

export default MarqueeText;
